import { useQuery } from '@apollo/client'

import * as styled from '../../../../util/styled'
import { Skeleton } from './Skeleton'
import { graphql } from '../../../../gql'
import { WebAndNewsResult } from './Result'

const skeletonArray = Array.from({ length: 10 }, (idx) => `${idx}`)

const Container = styled.section('mt-6')


const SearchWebAndNews = graphql(`
  query SearchWebAndNews($filter: WebAndNewsFilterInput!) {
    searchWebAndNews(filter: $filter) {
      items {
        description
        publishedAt
        thumbnail
        title
        url
      }
    }
  }
`)

type WebAndNewsProps = {
  query: string 
}

export const WebAndNews = (props: WebAndNewsProps) => {
  const { data, loading } = useQuery(SearchWebAndNews, {
    variables: {
      filter: {
        query: props.query,
        searchOpt: 'ai',
      }
    }
  })

  return (
    <Container>
      {loading && skeletonArray.map((_, i) => <Skeleton key={i} />)}
      {data?.searchWebAndNews?.items?.map((result, i) => (
        <WebAndNewsResult key={i} result={result} />
      ))}
    </Container>
  )
}
